module.exports = __webpack_public_path__ + "static/media/Codecademy.d7859a8c.png";